import {useEffect} from 'react';
import ics from 'ics';
import {saveAs} from 'file-saver';

const useSaveToCalender = (data) => {
  const ics = require('ics');

  const generateICS = () => {
    const date = new Date(data.deliverySlots.deliveryStartTime);
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // Month is zero-based, so add 1
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const eventDelivery = {
      start: [year, month, day, hour, minute],
      duration: {hours: 2},
      title: `שליחות ${window.Config.brand_Name_HE}`,
      description: '', // Replace with your title and logo logic
      location: '',
      status: 'CONFIRMED',
      busyStatus: 'BUSY',
    };

    ics.createEvent(eventDelivery, (error, value) => {
      if (!error) {
        const icsBlob = new Blob([value], {type: 'text/calendar;charset=utf8'});
        saveAs(icsBlob, 'event.ics');
      }
    });
  };

  generateICS();

  return null; // This hook doesn't return anything directly
};

export default useSaveToCalender;
